import { Component, input, output } from '@angular/core';

import { SaComponent } from 'smartauction-frontend-micro-library';
import { UpdateResultSummary } from '../../../interfaces/update-vehicles-action.interface';
import { UpdateErrorDisplay } from '../update-selected-modal/update-selected-modal.component';
import { ErrorIconComponent, SpinnerComponent } from 'remarketing-ui-components-lib';
import { CommonModule } from '@angular/common';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-multi-result-modal',
  imports: [SpinnerComponent, CommonModule, TranslocoDirective, ErrorIconComponent],
  templateUrl: './multi-result-modal.component.html',
  styleUrl: './multi-result-modal.component.scss'
})
export class MultiResultModalComponent extends SaComponent {

  protected readonly modalTemplateLabels$ = input<MultiResultModalTemplateLabels>();
  protected readonly isLoading$ = input<boolean>();
  protected readonly templateContent$ = input<MultiResultContentBase>({
    visibleTemplate: MultiResultModalTemplate.INITIAL_LOADING_TEMPLATE,
    happyPathData: undefined,
    errorPathData: undefined
  } as MultiResultContentBase);

  protected selectFailed = output<MultiResultContentBase>();
  protected resetGroundingModalTemplate = output<boolean>();
  protected close = output<boolean>();

  multiResultModalTemplateEnum = MultiResultModalTemplate;
  templatePunctuation = {
    period: '.',
    parenthesis: '(',
    closingParenthesis: ')',
    colonWithSpace: ': '
  };

  constructor() {
    super();
  }

  selectFailedVehicles(): void {
    this.selectFailed.emit(this.templateContent$());
  }

  makeTemplateInputDefault(): void {
    this.resetGroundingModalTemplate.emit(true);
  }

  get headerText(): string {
    return this.isHeaderTextAvailable ? this.templateContent$().headerText : '';
  }

  get successMessage(): string {
    const happyPath = this.templateContent$()?.happyPathData;
    return happyPath?.successMessage?.length ? happyPath.successMessage : '';
  }

  get failureLabelSingular(): string {
    const happyPath = this.templateContent$()?.happyPathData;
    return happyPath?.failureLabelSingular?.length ? happyPath?.failureLabelSingular : '';
  }

  get failureLabelPlural(): string {
    const happyPath = this.templateContent$()?.happyPathData;
    return happyPath?.failureLabelPlural?.length ? happyPath?.failureLabelPlural : '';
  }

  get errorMessage(): string {
    const errorPath = this.templateContent$()?.errorPathData;
    return errorPath?.errorMessage?.length ? errorPath.errorMessage : '';
  }

  get successVins(): string {
    const happyPath = this.templateContent$()?.happyPathData;
    return happyPath?.successVins?.length ? happyPath.successVins : '';
  }

  get isSuccessVins(): boolean {
    const successes = this.templateContent$()?.updateSummary?.successes;
    return successes !== undefined && successes !== null && successes.length > 0;
  }

  get isHeaderTextAvailable(): boolean {
    return !!this.templateContent$()?.headerText?.trim();
  }

  get isFailureVins(): boolean {
    const failures = this.templateContent$()?.updateSummary?.failures;
    return failures !== undefined && failures !== null && failures.length > 0;
  }

  handleCloseModal(): void {
    this.makeTemplateInputDefault();
    this.close.emit(true);
  }
}

export enum MultiResultModalTemplate {
  INITIAL_LOADING_TEMPLATE = 'initialLoadingTemplate',
  RESULTS_TEMPLATE = 'resultsTemplate',
  ERROR_TEMPLATE = 'errorTemplate'
}

export interface MultiResultContentBase {
  visibleTemplate: MultiResultModalTemplate;
  selectedVehicleCount: number;
  updateSummary: UpdateResultSummary;
  updateErrorDisplays: UpdateErrorDisplay[];
  headerText?: string;
  happyPathData?: MultiResultContentHappyPath;
  errorPathData?:MultiResultContentErrorPath;
}

export interface MultiResultContentHappyPath {
  successMessage: string;
  successVins: string;
  failureLabelSingular: string;
  failureLabelPlural: string;
}

export interface MultiResultContentErrorPath {
  errorMessage?: string;
}

export interface MultiResultModalTemplateLabels {
  modalName?: string;
  headline?: string;
  resultSummaryLabel?: string;
  close?: string;
  closeAndSelectFailed?: string;
}
